var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseOrderIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4173 2.04492L2.33398 7.87825V10.2116H24.5007V7.87825M18.6673 12.5449V20.7116H22.1673V12.5449M2.33398 26.5449H24.5007V23.0449H2.33398M11.6673 12.5449V20.7116H15.1673V12.5449M4.66732 12.5449V20.7116H8.16732V12.5449H4.66732Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseOrderIa);
export default __webpack_public_path__ + "static/media/releaseOrderIA.7db8dd0ae2415468942b1af7e31ef49e.svg";
export { ForwardRef as ReactComponent };